import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppToolkitModule } from './app-toolkit.module';
import { AppMaterialModule } from './app-material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
// import { OKTA_CONFIG, OktaAuthModule, OktaAuthGuard, OktaAuthService } from '@okta/okta-angular';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';

import { AlertComponent } from './shared/alert/alert.component';

import { HeaderComponent } from './shared/header/header.component';
import { FooterComponent } from './shared/footer/footer.component';
import { HomeComponent } from './home/home.component';
import { TerminationReportComponent } from './reports/terminationreport/terminationreport.component';
import { InternalErrorComponent } from './shared/error/internalerror/internalerror.component';
import { NotfoundComponent } from './shared/error/notfound/notfound.component';
import { LogoutComponent } from './logout/logout.component';
import { CallbackComponent } from './auth/callback/callback.component';

import { PowerBIService } from './reports/powerbiservice.service';
import { CustomOktaAuthService } from './auth/oktaauth.service';
import { CustomOktaAuthGuard } from './auth/oktaauth.guard';
import { AuthInterceptor } from './auth/auth.interceptor';
import { IAMRoleGuard } from './auth/roleguard.guard';

import { ErrorInterceptor } from './shared/error/error.interceptor';
import { UnauthorizedComponent } from './shared/error/unauthorized/unauthorized.component';
import { LoadingComponent } from './shared/loading/loading.component';

import { CompareGroupsComponent } from './comparegroup/comparegroups/comparegroups.component';
import { CompareGroupDetailComponent } from './comparegroup/comparegroupdetail/comparegroupdetail.component';
import { CompareGroupService } from './comparegroup/comparegroupservice.service';

import { NoDataComponent } from './shared/nodata/nodata.component';
import { Logger } from './shared/logger/logger.component';
import { LoadReportComponent } from './shared/loadreport/loadreport.component';
import { CaseyFinkExpComponent } from './reports/caseyfinkexp/caseyfinkexp.component';
import { LoadReportWithFiltersComponent } from './shared/loadreportwithfilters/loadreportwithfilters.component';
import { FilterService } from './shared/loadreportwithfilters/filterservice.service';
import { TokenRefreshComponent } from './shared/tokenrefresh/tokenrefresh.component';
import { LandingpageComponent } from './landingpage/landingpage.component';
import { SelfcomparegroupsComponent } from './comparegroup/selfcomparegroups/selfcomparegroups.component';
import { SelfCompareGroupDetailComponent } from './comparegroup/selfcomparegroupdetail/selfcomparegroupdetail.component';
import { LoadreportV2Component } from './shared/loadreport-v2/loadreport-v2.component';
import { ReportsDashboardComponent } from './reports/reports-dashboard/reports-dashboard.component';

@NgModule({
  declarations: [
    AlertComponent,
    
    CallbackComponent,
    CompareGroupsComponent,
    CompareGroupDetailComponent,
    FooterComponent,
    HeaderComponent,
    AppComponent,
    HomeComponent,
    InternalErrorComponent,
    LoadingComponent,
    LogoutComponent,
    NoDataComponent,
    NotfoundComponent,
    TerminationReportComponent,
    UnauthorizedComponent,
    LoadReportComponent,
    CaseyFinkExpComponent,
    LoadReportWithFiltersComponent,
    TokenRefreshComponent,
    LandingpageComponent,
    SelfcomparegroupsComponent,
    SelfCompareGroupDetailComponent,
    LoadreportV2Component,
    ReportsDashboardComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    AppToolkitModule,
    AppMaterialModule,
    FormsModule,
    HttpClientModule,
    ReactiveFormsModule
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    CompareGroupService,
    CustomOktaAuthService,
    CustomOktaAuthGuard,
    IAMRoleGuard,
    PowerBIService,
    Logger,
    FilterService
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
